import { Link } from "react-router-dom";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";

function HomeCta() {
  return (
    <MKBox component="section" py={{ xs: 5, md: 8 }}>
      <Container>
        <MKBox
          sx={{
            p: { xs: 3, md: 6 },
            borderRadius: 4,
            background: ({ functions: { linearGradient }, palette: { brand } }) =>
              linearGradient(brand.navy, brand.navyDark),
          }}
        >
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} md={7}>
              <MKTypography
                variant="h3"
                color="white"
                mb={1}
                sx={{ fontSize: { xs: "1.4rem", md: "2rem" } }}
              >
                Ready to get started?
              </MKTypography>
              <MKTypography variant="body2" color="white" opacity={0.85}>
                Tell us the class and subject, and we will find the right teacher. Teachers looking
                for work can register in a few minutes.
              </MKTypography>
            </Grid>
            <Grid item xs={12} md={5}>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={1.5}
                justifyContent={{ md: "flex-end" }}
              >
                <MKButton component={Link} to="/contact-us" variant="gradient" color="warning">
                  Find a tutor
                </MKButton>
                <MKButton
                  component={Link}
                  to="/tutor-registration"
                  variant="outlined"
                  color="white"
                >
                  Register as a tutor
                </MKButton>
              </Stack>
            </Grid>
          </Grid>
        </MKBox>
      </Container>
    </MKBox>
  );
}

export default HomeCta;
